module.exports = __webpack_public_path__ + "img/L1.5f410e4e.png";